import { Loader } from "@googlemaps/js-api-loader";

// Global Collections
var tollersMaps = tollersMaps || [];
var tollersData = tollersData || { contactPlaceIDs: [] };

// apiKey: "AIzaSyATwT9dMisgx-VDxjQALRkQAEZzEDTbAMA", // Staging
const loader = new Loader({
    apiKey: "AIzaSyAVnyaxzltYFp-ADntY53KPZT1zixixduA", // Live
    version: "weekly"
});

loader.load().then(() => {
    const { Map, Geocoder, InfoWindow, Marker } = google.maps;

    // Executed once Google Maps has loaded
    function tollersGMapsReady() {
        // Find all elements which are to have maps created
        var mapElements = document.getElementsByClassName('gmap');

        if (mapElements.length > 0) {
            var geocoder = new Geocoder();

            // Create a map for each element
            for (var i = 0; i < mapElements.length; i++) {
                var mapElement = mapElements[i];
                var infoWindow = new InfoWindow();

                // Initialise the map on the page
                var map = new Map(mapElement, {
                    center: { lat: 52.239860, lng: -0.904089 },
                    zoom: 8,
                    disableDefaultUI: true
                });

                // Store the map in the global collection using its specified name so it can be accessed elsewhere
                tollersMaps.push({
                    name: mapElement.getAttribute('data-map-name'),
                    map: map
                });

                // Add all the places to the map
                window.tollersData.contactPlaceIDs.forEach(function(placeID) {
                    // Geocodes the place ID and adds a marker and info window to the map
                    tollersGeocodePlace(placeID, geocoder, map, infoWindow);
                });
            }
        }
    }

    // Geocodes a provided place ID and adds it to the specified map
    function tollersGeocodePlace(placeID, geocoder, map, infoWindow) {
        geocoder.geocode({ 'placeId': placeID }, function(results, status) {
            if (status === 'OK') {
                if (results[0]) {
                    // Create a marker for each place
                    var marker = new Marker({
                        map: map,
                        position: results[0].geometry.location
                    });

                    // Store the place ID against the marker so it can retrieve its address on click
                    marker.place = placeID;

                    marker.addListener('click', function() {
                        // Retrieve the element with the formatted address for this marker's place
                        var addressElement = document.querySelector('[data-place-id="' + this.place + '"]').cloneNode(true);

                        // Check if the addressElement has the class 'location-detail'
                        if (addressElement.querySelector('.location-detail')) {
                            // Reset the matchHeight changes
                            addressElement.querySelector('.location-detail').style.height = 'auto';
                        }

                        // Update the info window and display it above the marker
                        infoWindow.setContent(addressElement);
                        infoWindow.open(map, marker);

                        // Centre on the selected marker
                        map.setCenter(this.position);
                    });
                } else {
                    console.error('Geocoding: no results found for place ID: ' + placeID);
                }
            } else {
                console.error('Geocoding failed for place ID ' + placeID + ' due to: ' + status);
            }
        });
    }

    // Initialize maps after the library has been loaded
    tollersGMapsReady();
});
